import {Component, Input} from "@angular/core";

@Component({
    selector: "woa-receipt",
    templateUrl: "./receipt.component.html"
})
export class ReceiptComponent {
    @Input() receiptXml: string;

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/receipt/receipt.component.ts